let labels = {
    name: 'Name',
    retailPrice: 'MSRP',
    upc: 'UPC',
    category: 'Category',
    type: 'Type',
    design: 'Design Tags',
    description: 'Description'
};

export default labels;